import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Linkedin, MapPin } from 'lucide-react';
import { mockData } from '../data/mock';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="heading-5">Dream Sports Foundation</h3>
            <div className="footer-address">
              <p className="body-small">
                Office Address:<br />
                7th Floor, Ascent,<br />
                Sudam Kalu Ahire Marg, opposite GSK,<br />
                Worli, Mumbai - 400030.
              </p>
              <a 
                href="https://www.google.com/maps/place/Ascent/@19.0075088,72.8206576,321m/data=!3m1!1e3!4m6!3m5!1s0x3be7cffc29340887:0xe8e0c6c6717a65a8!8m2!3d19.0079375!4d72.8205625!16s%2Fg%2F11m799w3rt?entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoASAFQAw%3D%3D" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="map-link"
              >
                <MapPin size={18} />
                <span>View on Google Maps</span>
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="heading-6">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/programs" className="footer-link">Programs</Link></li>
              <li><Link to="/media" className="footer-link">Media</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="heading-6">Connect With Us</h4>
            <div className="social-links">
              <a href={mockData.socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <Instagram size={24} />
              </a>
              <a href={mockData.socialMedia.twitter} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter">
                <Twitter size={24} />
              </a>
              <a href={mockData.socialMedia.linkedin} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                <Linkedin size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="caption">© {new Date().getFullYear()} Dream Sports Foundation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;